window.JRS = window.JRS || {};

(function(JRS) {
  'use strict';

  /** @type {Object<string, function[]>} */
  var handlers = {};

  /**
   * Subscribe to an event. Returns an unsubscribe function.
   * @param {string} eventName
   * @param {function} handler
   * @returns {function}
   */
  function on(eventName, handler) {
    if (!handlers[eventName]) handlers[eventName] = [];
    handlers[eventName].push(handler);
    return function unsubscribe() {
      off(eventName, handler);
    };
  }

  /**
   * Subscribe to an event, but only fire once.
   * @param {string} eventName
   * @param {function} handler
   * @returns {function}
   */
  function once(eventName, handler) {
    function wrapper(data) {
      try {
        handler(data);
      } finally {
        off(eventName, wrapper);
      }
    }
    return on(eventName, wrapper);
  }

  /**
   * Emit an event with data.
   * @param {string} eventName
   * @param {Object} [data]
   * @returns {void}
   */
  function emit(eventName, data) {
    if (!handlers[eventName]) return;
    if (typeof data === 'undefined') data = {};
    var list = handlers[eventName].slice();
    for (var i = 0; i < list.length; i++) {
      try {
        list[i](data);
      } catch (error) {
        console.error('[JRS EventBus] Handler error for event "' + eventName + '"', error);
      }
    }
  }

  /**
   * Remove a specific handler from an event.
   * @param {string} eventName
   * @param {function} handler
   * @returns {void}
   */
  function off(eventName, handler) {
    var list = handlers[eventName];
    if (!list) return;
    var index = list.indexOf(handler);
    if (index === -1) return;
    list.splice(index, 1);
    if (list.length === 0) delete handlers[eventName];
  }

  /**
   * Clear all handlers for one event, or all events.
   * @param {string} [eventName]
   * @returns {void}
   */
  function reset(eventName) {
    if (typeof eventName === 'undefined') {
      handlers = {};
      return;
    }
    delete handlers[eventName];
  }

  JRS.EventBus = { on: on, once: once, emit: emit, off: off, reset: reset };
})(window.JRS);
